/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-29 09:31:56
 * @LastEditors: limin
 * @LastEditTime: 2021-04-23 18:15:46
 */
const routesKeys = Object.freeze([
  {
    name: "home",
    meta: {
      title: '嘀加商城',
      keepAlive: true,
      deepth:1 //标识路由的深度 数字越大深度越深 (用于判断路由的前进与返回)
    }
  },
  {
    name: "category",
    meta: {
      title: '分类',
      deepth:2,
      keepAlive: true,
    }
  },
  {
    name: "goodsList",
    meta: {
      title: '商品列表',
      keepAlive: true,
      deepth:3
    }
  },
  {
    name: "goodsDetail",
    meta: {
      title: '商品详情',
      deepth:4
    }
  },
  {
    name: "confirmOrder",
    meta: {
      title: '确认订单',
      deepth:5
    }
  },
  {
    name: "cart",
    meta: {
      title: '购物车',
      keepAlive: true,
      deepth:6
    }
  },
  {
    name: "myOrder",
    meta: {
      title: '我的订单',
      deepth:1
    }
  },
  {
    name: "orderList",
    meta: {
      title: '订单列表',
      keepAlive: true,
      deepth:2
    }
  },
  {
    name: "orderDetail",
    params: "orderCode",
    meta: {
      title: '订单详情',
      deepth:3
    }
  },
  {
    name: "myAddress",
    meta: {
      title: '我的地址',
      deepth:2
    }
  },
  {
    name: "addAddress",
    meta: {
      title: '添加地址',
      deepth:5
    }
  },
  {
    name: "editAddress",
    meta: {
      title: '编辑地址',
      keepAlive: true,
      deepth:5
    }
  },
  {
    name: "mine",
    meta: {
      title: '我的',
      deepth:1
    }
  },
  {
    name: 'paymentFailure',
    meta: {
      title: '支付失败',
      deepth:7
    }
  },
  {
    name: 'paymentSuccess',
    meta: {
      title: '支付成功',
      deepth:7
    }
  },
  {
    name: 'searchAddress',
    meta: {
      title: '查询地址',
      deepth:3
    }
  }
]);
let keepAlives= []
const routes = routesKeys.map(key => {
  const { name, params, meta } = key;
  if(meta.keepAlive){
    keepAlives.push(name)
  }
  const com = name.charAt(0).toUpperCase() + name.slice(1);
  let path = `/${name}`;
  if (params) {
    path = `${path}/:${params}`;
  }
  return {
    path,
    name,
    component: resolve => require([`@/views/${com}.vue`], resolve),
    meta
  };
});
routes.push({ path: "*", redirect: "/home" });
export const keeps =keepAlives
export default routes;
